<cx-icon class="tab__icon" [type]="icon">
  <div *ngIf="badgeCount > 0 as hasBadge" class="tab__icon__badge">
    {{ badgeCount }}
  </div>
</cx-icon>
<span class="tab__label">
  {{ label }}
</span>
